/*eslint-disable*/
import React from "react";
import { Table, Row, Col } from "antd";
import "./styles/AppView.css";

export default (props) => {
  const { data, columns, onRowSelect, rowClassName, expandable, onChange } = props;
  return (
    <Row>
      <Col span={24}>
        <Table
          // key={data}
          pagination={false}
          // onRow={(record, rowIndex) => {
          //   return {
          //     onClick: (event) => onRowSelect(record),
          //   };
          // }}

          onRow={(record) => ({
            onClick: () => {
              if (typeof onRowSelect === "function") {
                onRowSelect(record);
              }
            },
          })}
          onChange={onChange}
          expandable={expandable}
          columns={columns ? columns : columns}
          dataSource={data ? data : data}
          rowKey='id'
          scroll={{
            x:  "max-content",
            y: data?.length > 10 ? 800 : undefined,
          }}
          sticky
          size="small"
          rowClassName={rowClassName}
        />
      </Col>
    </Row>
  );
};
